import config from './index.json';

const environmentMapping = {
  'dev-agendaprofissional.medex.net.br': 'development',
  'dev-agendaprofissional.bhiotrack.com.br': 'development',
  'uat-agendaprofissional.medex.net.br': 'uat',
  'uat-agendaprofissional.bhiotrack.com.br': 'uat',
  'ppr-agendaprofissional.medex.net.br': 'partner',
  'ppr-agendaprofissional.bhiotrack.com.br': 'partner',
};

const currentHost = location.host;
const currentEnvironment = environmentMapping[currentHost] || process.env.NODE_ENV || 'production';

export const environments = {
  partner: config[currentEnvironment]?.partner || config.production.partner,
  backend: config[currentEnvironment]?.backend || config.production.backend,
  tmed: config[currentEnvironment]?.tmed || config.production.tmed,
  memed: config[currentEnvironment]?.memed || config.production.memed,
  partners: config[currentEnvironment]?.partners || config.production.partners,
};
